import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Step1Component from '../../../pages/newRegisterSections/Step1Component';
import Step2Component from '../../../pages/newRegisterSections/Step2Component';
import Step3Component from '../../../pages/newRegisterSections/Step3Component';
import Step4Component from '../../../pages/newRegisterSections/Step4Component';
import Step5Component from '../../../pages/newRegisterSections/Step5Component';
import Step6Component from '../../../pages/newRegisterSections/Step6Component';
import Step7Component from '../../../pages/newRegisterSections/Step7Component';
import Step8Component from '../../../pages/newRegisterSections/Step8Component';
import Step9Component from '../../../pages/newRegisterSections/Step9Component';
import Step10Component from '../../../pages/newRegisterSections/Step10Component';
import Step11Component from '../../../pages/newRegisterSections/Step11Component';
// import Step12Component from '../../../pages/newRegisterSections/Step12Component';
import Step13Component from '../../../pages/newRegisterSections/Step13Component';
import Step14Component from '../../../pages/newRegisterSections/Step14Component';
import Step15Sub1Component from '../../../pages/newRegisterSections/Step15Sub1Component';
import Step15Sub2Component from '../../../pages/newRegisterSections/Step15Sub2Component';
import UpdateProfile from '../../../pages/newRegisterSections/UpdateProfile';
import AppConstants from '../../../appConstants';
import webServices from '../../../services/webServices';

const AffiliateRegisterActionComponent = () => {
  const history = useHistory();
  const [step, setStep] = useState(1);
  const [masterData, setMasterData] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const handleNext = (val) => {
    setStep(val);
  };

  useEffect(async () => {
    const resp = await webServices.getCommonMasterData();
    if (resp && resp?.success) {
      setMasterData(resp?.data);
    }

    const user = await webServices.getUserDetail();
    if (user && user?.success === true) {
      setUserDetails(user?.data);
      const uDetails = user?.data;
      const showAffiliateProfileFrm = window.localStorage.getItem('show_affiliate_profile_incomplete_form');

      if (
        uDetails?.is_profile_completed === 'NO' ||
        (`${uDetails?.is_affiliate}` === '1' && uDetails?.is_affiliate_dating_profile_completed !== 'YES' && showAffiliateProfileFrm === 'YES')
      ) {
        setStep(16);
      } else if (uDetails?.is_profile_completed === 'YES') {
        history.push(AppConstants.routes.affiliate.dashboard);
      } else if (uDetails?.is_otp_valid === '1') {
        setStep(2);
      } else {
        setStep(1);
      }
    }
  }, []);

  return (
    <>
      {step === 1 && (
        <Step1Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={2}
        />
      )}
      {step === 2 && (
        <Step2Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={3}
        />
      )}
      {step === 3 && (
        <Step3Component
          handleNext={handleNext}
          userDetails={userDetails}
          masterData={masterData}
          step={4}
        />
      )}
      {step === 4 && (
        <Step4Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={5}
        />
      )}
      {step === 5 && (
        <Step5Component
          handleNext={handleNext}
          userDetails={userDetails}
          masterData={masterData}
          step={6}
        />
      )}
      {step === 6 && (
        <Step6Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={7}
        />
      )}
      {step === 7 && (
        <Step7Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={8}
        />
      )}
      {step === 8 && (
        <Step8Component
          handleNext={handleNext}
          userDetails={userDetails}
          masterData={masterData}
          step={9}
        />
      )}
      {step === 9 && (
        <Step9Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={10}
        />
      )}
      {step === 10 && (
        <Step10Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={11}
        />
      )}
      {step === 11 && (
        <Step11Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={12}
        />
      )}
      {/* {step === 12 && (
        <Step12Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={13}
        />
      )} */}
      {step === 12 && (
        <Step13Component
          handleNext={handleNext}
          userDetails={userDetails}
          masterData={masterData}
          step={13}
        />
      )}
      {step === 13 && (
        <Step14Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={14}
        />
      )}
      {step === 14 && (
        <Step15Sub1Component
          handleNext={handleNext}
          userDetails={userDetails}
          step={15}
        />
      )}
      {step === 14 && (
        <Step15Sub2Component
          // handleNext={handleNext}
          userDetails={userDetails}
          // step={15}
        />
      )}
      {step === 16 && (
        <UpdateProfile
          userDetails={userDetails}
          masterData={masterData}
          // history={history}
          // step={15}
        />
      )}
    </>
  );
};

export default AffiliateRegisterActionComponent;
